import React from "react";

const ProductTable = ({ title, data }) => {
  if (!data || data.length === 0) return null;

  const headers = data[0];
  const rows = data.slice(1);

  return (
    <div className="sm:p-3">
      <h3 className="wordGradient font-semibold text-[1.5rem] md:text-[2rem] 2xl:text-[2.3rem]  mb-4">
        {title}
      </h3>

      <div className="overflow-x-auto sm:pl-3">
        <div className=" rounded-xl overflow-hidden border border-[#444D61] shadow-sm ">
          <table className="w-full text-xs sm:text-sm  border-collapse border-spacing-0">
            <thead>
              <tr className="bg-black text-left text-[#1B99D4] border-b border-[#444D61]">
                {headers.map((header, index) => (
                  <th key={index} className="p-3">
                    {header}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody className="text-white bg-black">
              {rows.map((row, i) => (
                <tr key={i} className="border-b border-[#444D61]">
                  {row.map((cell, j) => (
                    <td key={j} className="py-1 px-3">
                      {cell}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const IOTable = ({ title, data }) => {
  if (!data || data.length === 0) return null;

  const headers = data[0];
  const rows = data.slice(1);

  return (
    <div className="p-3">
      <h3 className="wordGradient font-semibold text-[1.5rem] md:text-[2rem] 2xl:text-[2.3rem]  mb-4">
        {title}
      </h3>

      <div className="overflow-x-auto pl-3">
        <div className="w-full rounded-xl overflow-hidden border  border-[#444D61] shadow-sm">
          <table className="w-full text-sm border-collapse border-spacing-0">
            <thead>
              <tr className="bg-black text-left text-[#1B99D4] border-b border-[#444D61]">
                {headers.map((header, index) => (
                  <th key={index} className="p-3">
                    {header}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody className="text-white bg-black">
              {rows.map((row, i) => (
                <tr key={i} className="border-b border-[#444D61]">
                  {row.map((cell, j) => (
                    <td key={j} className="py-1 px-3">
                      {cell}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export { ProductTable, IOTable };
